export default __webpack_public_path__ + "static/generic-hero-robot-dc746790e27b29252c3b8185e7878f88.png";